import styled from "styled-components/macro";

export const Container = styled.div`
  background: var(--container-color);
  border-radius: 40px;
  padding: 15px 25px;
  margin-bottom: 20px;
  position: relative;

  p {
    display: block;
    margin-right: 2em;

    &:last-child {
      margin-bottom: 0;
    }
  }

  svg {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 50%;
    transform: translateY(-55%);
    right: 20px;
  }

  &.sw2 {
    background: var(--menu-color);
    border-radius: 24px;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15), 0px 0px 2px 0px rgba(0, 0, 0, 0.25);
    padding: 16px 16px 16px 19px;
    margin: 0 16px 16px 16px;

    p {
      color: var(--grey-0);
      font-size: 15px;
      font-weight: 500;
    }
  }
`;
